import {
  StyledCategoryContent,
  StyledCategoryItem
} from './CategoriesList.style';
import ToggleBox from 'components/ToggleBox';
import CategoryFilters from './CategoryFilters/CategoryFilters';
import { toggleCategoryToolBox } from '../../useFormState/form.state.actions';
import CategoryItemTitle from './CategoryItemTitle';

const CategoryItem = ({
  category,
  pmFilters,
  dispatch,
  isCollapsed,
  onOrderUp,
  onOrderDown
}) => {
  return (
    <StyledCategoryItem>
      <ToggleBox
        isControlled
        collapsed={isCollapsed}
        title={
          <CategoryItemTitle
            category={category}
            onOrderUp={onOrderUp}
            onOrderDown={onOrderDown}
          />
        }
        onClick={() => dispatch(toggleCategoryToolBox(category))}
      >
        <StyledCategoryContent>
          <CategoryFilters
            category={category}
            pmFilters={pmFilters}
            dispatch={dispatch}
          />
        </StyledCategoryContent>
      </ToggleBox>
    </StyledCategoryItem>
  );
};

export default CategoryItem;
